import { Router, NavigationEnd } from '@angular/router';

import { Component, Inject, ElementRef, OnInit, Renderer2, HostListener, OnDestroy, DOCUMENT, ChangeDetectionStrategy } from '@angular/core';
import { RouteInfo } from './sidebar.metadata';
import { AuthService } from 'src/app/all-modules/core/service/auth.service';
import { UserLoginReponse } from 'src/app/all-modules/core/models/user';
import { BehaviorSubject } from 'rxjs';
import { UserManagementService } from 'src/app/all-modules/admin/services/user-management/user-management.service';
import { CommonService } from 'src/app/all-modules/shared/services/common.service';
import { APP_CONSTANTS, MODULE_CONSTANTS, SIDEBAR_MENU_VISIBILITY_CHECK_CONSTANTS } from 'src/app/all-modules/shared/constants/constant';
import { SidebarMenuService } from 'src/app/all-modules/shared/services/sidebar-menu-service';
import { loggedInUserViewModel, roleModuleAccess } from 'src/app/all-modules/admin/models/user-management/user_models';
@Component({
    selector: 'app-sidebar',
    templateUrl: './sidebar.component.html',
    styleUrls: ['./sidebar.component.sass'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class SidebarComponent implements OnInit, OnDestroy {
  public sidebarItems!: RouteInfo[];
  public innerHeight?: number;
  public bodyTag!: HTMLElement;
  listMaxHeight?: string;
  listMaxWidth?: string;
  userFullName?: string;
  userImg?: string;
  userType?: string;
  headerHeight = 60;
  currentRoute?: string;
  routerObj;
  currentUser: any;
  loggedInUserDetails!: loggedInUserViewModel;
  profileImage = '';
  roleDisplayName: string = "";
  constructor(
    @Inject(DOCUMENT) private document: Document,
    private renderer: Renderer2,
    public elementRef: ElementRef,
    private authService: AuthService, private userService: UserManagementService, private sidebarMenuService: SidebarMenuService,
    private router: Router, private commonService: CommonService
  ) {
    this.routerObj = this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        // close sidebar on mobile screen after menu select
        this.renderer.removeClass(this.document.body, 'overlay-open');
        this.sidebbarClose();
        // this.renderer.addClass(this.document.body, 'side-closed');
        // this.renderer.addClass(this.document.body, 'submenu-closed');
      }
    });
    this.commonService.loggedInUserDetails$.subscribe((user: loggedInUserViewModel) => {
      if (!!user) {
        this.loggedInUserDetails = user;
        this.roleDisplayName = this.loggedInUserDetails.roleDisplayName;
        if (this.loggedInUserDetails.profilePicBase64 != null) {
          this.profileImage = 'data:image/png;base64,' + this.loggedInUserDetails.profilePicBase64;
        }
        else {
          this.profileImage = "assets/images/empty-profile.png";
        }
      }
    });
    this.currentUser = this.authService.currentUserValue;
  }
  @HostListener('window:resize')
  windowResizecall() {
    if (window.innerWidth < 1025) {
      this.renderer.removeClass(this.document.body, 'side-closed');
    }
    this.setMenuHeight();
    this.checkStatuForResize(false);
  }
  @HostListener('document:mousedown', ['$event'])
  onGlobalClick(event: Event): void {
    if (!this.elementRef.nativeElement.contains(event.target)) {
      this.renderer.removeClass(this.document.body, 'overlay-open');
      this.sidebbarClose();
    }
  }
  callToggleMenu(event: Event, length: number) {
    if (length > 0) {
      const parentElement = (event.target as HTMLInputElement).closest('li');
      const activeClass = parentElement?.classList.contains('active');

      if (activeClass) {
        this.renderer.removeClass(parentElement, 'active');
      } else {
        this.renderer.addClass(parentElement, 'active');
      }
    }
  }
  ngOnInit() {
    this.sidebarItems = [];
    if (this.authService.currentUserValue) {
      this.commonService.moduleDetails$.subscribe((user: roleModuleAccess[]) => {
        if (this.commonService.isNotNULLEmptyUndefindArray(user)) {
          let moduleAccess = this.commonService.getModuleAccess();
          if (this.commonService.isNotNULLEmptyUndefindArray(moduleAccess)) {
            this.sidebarItems = [];
            this.sidebarMenuService.getSidebarRoutesData().forEach(element => {
              let sidebarMainMenu: RouteInfo;
              let checkModuleKeys = moduleAccess.find(a1 =>
                element.moduleKey.some(a2 => a1.moduleKey === a2));
              if (checkModuleKeys === null || checkModuleKeys === undefined) {
                checkModuleKeys = moduleAccess.find(a1 =>
                  element.groupKey.some(a2 => a1.groupKey === a2));
              }
              let isCommonModuleKeyMain = false;
              if (checkModuleKeys === null || checkModuleKeys === undefined) {
                let commonModule = element.moduleKey.find(module => module === MODULE_CONSTANTS.COMMON);
                if (this.commonService.isNotNULLEmptyUndefind(commonModule)) {
                  isCommonModuleKeyMain = true;
                }
              }
              // let checkMainMenu = moduleAccess.find(r => (r.moduleKey === element.moduleKey || r.moduleKey === MODULE_CONSTANTS.COMMON));
              // if(checkMainMenu === null || checkMainMenu === undefined) {
              //    checkMainMenu = moduleAccess.find(r => (r.groupKey === element.groupKey));
              // }
              if ((checkModuleKeys !== null && checkModuleKeys !== undefined) || isCommonModuleKeyMain) {
                let isValidOtherVisibilityMain = this.isValidOtherVisibility(element.checkOtherForVisibility);
                if (isValidOtherVisibilityMain) {
                  let originalElement = Object.assign({}, element)
                  sidebarMainMenu = element;
                  sidebarMainMenu.submenu = new Array<RouteInfo>();
                  originalElement.submenu.forEach(elementFirstLevel => {
                    let isValidOtherVisibilityFirstLevel = this.isValidOtherVisibility(elementFirstLevel.checkOtherForVisibility);
                    if (isValidOtherVisibilityFirstLevel) {
                        let checkMainMenuFirstLevel = moduleAccess.find(a1 =>
                        elementFirstLevel.moduleKey.some(a2 => a1.moduleKey === a2));
                        let isCommonModuleKeyFirstLevel= false;
                        if (checkMainMenuFirstLevel === null || checkMainMenuFirstLevel === undefined) {
                          let commonModule = elementFirstLevel.moduleKey.find(module => module === MODULE_CONSTANTS.COMMON);
                          if (this.commonService.isNotNULLEmptyUndefind(commonModule)) {
                            isCommonModuleKeyFirstLevel = true;
                          }
                        }
                        if (this.commonService.isNotNULLEmptyUndefind(checkMainMenuFirstLevel)  || isCommonModuleKeyFirstLevel) {
                        let sidebarMainMenuSecond = Object.assign({}, elementFirstLevel)
                        sidebarMainMenuSecond.submenu = new Array<RouteInfo>();
                        elementFirstLevel.submenu.forEach(elementSecond => {
                          let isValidOtherVisibilitySecondLevel = this.isValidOtherVisibility(elementSecond.checkOtherForVisibility);
                          if (isValidOtherVisibilitySecondLevel) {
                            let checkMainMenuSecondLevel = moduleAccess.find(a1 =>
                              elementSecond.moduleKey.some(a2 => a1.moduleKey === a2 || a1.moduleKey === MODULE_CONSTANTS.COMMON));
                              let isCommonModuleKeySecondLevel= false;
                              if (checkMainMenuSecondLevel === null || checkMainMenuSecondLevel === undefined) {
                                let commonModule = elementSecond.moduleKey.find(module => module === MODULE_CONSTANTS.COMMON);
                                if (this.commonService.isNotNULLEmptyUndefind(commonModule)) {
                                  isCommonModuleKeySecondLevel = true;
                                }
                              }
                              if (this.commonService.isNotNULLEmptyUndefind(checkMainMenuSecondLevel) || isCommonModuleKeySecondLevel) {
                              sidebarMainMenuSecond.submenu.push(elementSecond);
                            }
                          }
                        });
                        if (this.commonService.isNotNULLEmptyUndefind(sidebarMainMenuSecond)) {
                          sidebarMainMenu.submenu.push(sidebarMainMenuSecond);
                        }
                      }
                    }
                  });
                  if (this.commonService.isNotNULLEmptyUndefind(sidebarMainMenu)) {
                    this.sidebarItems.push(sidebarMainMenu);
                  }
                }
              }
            });
          }

        } else {
          this.sidebarItems = [];
          this.sidebarMenuService.getSidebarRoutesData().forEach(element => {
            if (this.commonService.isNotNULLEmptyUndefindArray(element.checkOtherForVisibility)) {
              let isValidOtherVisibilityMain = this.isValidOtherVisibility(element.checkOtherForVisibility);
              if (isValidOtherVisibilityMain === true) {
                this.sidebarItems.push(element);
              }
            }
          })
        }
      });
    }
    this.currentUser = new BehaviorSubject<UserLoginReponse>(JSON.parse(localStorage.getItem('currentUser') || '{}'));
    //this.GetLoggedInUserDetails();
    this.initLeftSidebar();
    this.bodyTag = this.document.body;
  }
  isValidOtherVisibility(visibility: string[]): boolean {
    if (this.commonService.isNotNULLEmptyUndefindArray(visibility)) {
      const checkMainMenuSecondLevel = visibility.find((r: string) => r == SIDEBAR_MENU_VISIBILITY_CHECK_CONSTANTS.WEEKLY_MEET);
      if (this.commonService.isNotNULLEmptyUndefind(checkMainMenuSecondLevel)) {
        let isVisibility = this.authService.currentUserValue.isAllowWeeklyMeetPermission;
        if (this.commonService.isNotNULLEmptyUndefind(isVisibility) && isVisibility === true) {
          return true;
        } else {
          return false;
        }
      }
    }
    return true;
  }
  ngOnDestroy() {
    this.routerObj.unsubscribe();
  }
  initLeftSidebar() {
    // eslint-disable-next-line @typescript-eslint/no-this-alias
    const _this = this;
    // Set menu height
    _this.setMenuHeight();
    _this.checkStatuForResize(true);
  }
  setMenuHeight() {
    this.innerHeight = window.innerHeight;
    const height = this.innerHeight - this.headerHeight;
    this.listMaxHeight = height + '';
    this.listMaxWidth = '500px';
  }
  isOpen() {
    return this.bodyTag.classList.contains('overlay-open');
  }
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  checkStatuForResize(firstTime: boolean) {
    if (window.innerWidth < 1025) {
      this.renderer.addClass(this.document.body, 'sidebar-gone');
    } else {
      this.renderer.removeClass(this.document.body, 'sidebar-gone');
    }
  }
  mouseHover() {
    const body = this.elementRef.nativeElement.closest('body');
    if (body.classList.contains('submenu-closed')) {
      this.renderer.addClass(this.document.body, 'side-closed-hover');
      this.renderer.removeClass(this.document.body, 'submenu-closed');
    }
  }
  mouseOut() {
    const body = this.elementRef.nativeElement.closest('body');
    if (body.classList.contains('side-closed-hover')) {
      this.renderer.removeClass(this.document.body, 'side-closed-hover');
      this.renderer.addClass(this.document.body, 'submenu-closed');
    }
  }

  sidebbarClose() {
    if (window.innerWidth < 1025) {
      this.renderer.addClass(this.document.body, 'sidebar-gone');
    }
  }
  // GetLoggedInUserDetails() {
  //   this.userService.GetLoggedInUserDetails().subscribe(
  //     (res: any) => {
  //       if (res != null && res != undefined) {
  //         this.loggedInUserDetails = res;
  //         if (this.loggedInUserDetails.profilePicBase64 != null) {
  //           this.profileImage = 'data:image/png;base64,' + this.loggedInUserDetails.profilePicBase64;
  //         }
  //         else {
  //           this.profileImage = "../../../assets/images/empty-profile.png";
  //         }
  //       }
  //     },
  //     (error) => {
  //     });
  // }
  protected readonly APP_CONSTANTS = APP_CONSTANTS;
}
